import CountryRegionTrailsModule, {CountryRegionTrailsState} from "./modules/CountryRegionTrailsModule";
import {Store, createStore } from "vuex";

export interface RootState {
  countryRegionTrails: CountryRegionTrailsState
}

export const store: Store<RootState> = createStore({
  modules: {
    countryRegionTrails: new CountryRegionTrailsModule(),
  }
});

store.subscribe((mutation, state) => {
  if (
    mutation.type === 'countryRegionTrails/setDistanceRangeMax' ||
    mutation.type === 'countryRegionTrails/setElevations' ||
    mutation.type === 'countryRegionTrails/setDifficulties' ||
    mutation.type === 'countryRegionTrails/removeTrailTag' ||
    mutation.type === 'countryRegionTrails/addTrailTag' ||
    mutation.type === 'countryRegionTrails/setSelectedTrailTags'
  ) {
    store.dispatch('countryRegionTrails/getTypesenseResponse')
  }
})
